export const ContactScreen = () => `
    <div id="contact-screen" class="screen">
        <script>
            // Redirect to single page contact section
            window.location.hash = "#contact-section";
            document.getElementById('contact-section')?.scrollIntoView({ behavior: 'smooth' });
        </script>
    </div>
`;
